import React from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card, Form } from 'react-bootstrap';
import TableElement from '../../../Utils/elements/TableElement';

export default function ProfitLoss() {
    // Profit & Loss Expense 
    const acReortsPLExpense = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Expense', 'Amount'],
        tbody: [
            { expense: { type: 'text', text: 'Purchase Invoice' }, amount: { type: 'text', text: '105476.00' }},
            { expense: { type: 'text', text: 'Expense' }, amount: { type: 'text', text: '69618.00' }},
            { expense: { type: 'text', text: 'Sales Return' }, amount: { type: 'text', text: '29142.31' }},
            { expense: { type: 'text', text: 'On Account' }, amount: { type: 'text', text: '20.00' }},
            { expense: { type: 'text', text: 'Total Expense' }, amount: { type: 'text', text: '204256.31' }, rowhighlight: true },
            { expense: { type: 'text', text: 'Net Profit' }, amount: { type: 'text', text: '575599.19' }},
            { expense: { type: 'text', text: 'Total Amount' }, amount: { type: 'text', text: '575599.19' }, rowhighlight: true }
        ]
    };

    // Profit & Loss Income 
    const acReortsPLIncome = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Income', 'Amount'],
        tbody: [
            { income: { type: 'text', text: 'Invoice' }, amount: { type: 'text', text: '764258.00' }},
            { income: { type: 'text', text: 'Purchase Return' }, amount: { type: 'text', text: '15597.50' }},
            { income: { type: 'text', text: 'Total Income' }, amount: { type: 'text', text: '779855.5' }, rowhighlight: true },
            { income: { type: 'text', text: 'Net Loss' }, amount: { type: 'text', text: '0' }},
            { income: { type: 'text', text: 'Total Amount' }, amount: { type: 'text', text: '0' }, rowhighlight: true }
        ]
    };

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-sm-flex justify-content-between align-items-center mb-3">
                                            <Card.Title className='mb-3 mb-sm-0'>Profit & Loss</Card.Title>
                                            <Form>
                                                <Form.Select size="sm">
                                                    <option>All Time</option>
                                                    <option value="1">One</option>
                                                    <option value="2">Two</option>
                                                </Form.Select>
                                            </Form>
                                        </div>
                                        <Row>
                                            <Col xl={6}>
                                                <TableElement tableClass={acReortsPLExpense.tableClass} thead={acReortsPLExpense.thead} tbodydata={acReortsPLExpense.tbody} />
                                            </Col>
                                            <Col xl={6}>
                                                <TableElement tableClass={acReortsPLIncome.tableClass} thead={acReortsPLIncome.thead} tbodydata={acReortsPLIncome.tbody} />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
